<template>
  <tr>
    <td>
      <v-tooltip bottom class="right btn-group">
        <v-btn small icon slot="activator" @click="removeItem(cartItem.id)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
        <span>Remove from cart</span>
      </v-tooltip>
      <div>{{cartItem.name}}</div>
    </td>
    <td class="right-align" width=1>
      <v-text-field
        @keyup.enter="updateItem()"
        @blur="updateItem()"
        v-model="cartItem.quantity"
        class="right-align tight no-label"
        maxlength="3"
      ></v-text-field>
    </td>
    <td class="right-align" width=1>
      {{unitPrice * cartItem.quantity | currency}}
    </td>
  </tr>
</template>

<script>
  import Events from '@/api/events'

  export default {
    props: {
      index: { type: Number, required: true },
      cartItem: { type: Object, required: true }
    },

    watch: {
      'cartItem.quantity': function () {
        if (parseInt(this.cartItem.quantity) >= 500) {
          this.cartItem.quantity = 1
          Events.$emit('error', 'Please Contact Gung-Ho for pricing on 500+ quantities')
        }
      }
    },

    computed: {
      unitPrice () {
        if (this.cartItem.quantity >= 250) return this.cartItem.unit_prices[250]
        else if (this.cartItem.quantity >= 100) return this.cartItem.unit_prices[100]
        else if (this.cartItem.quantity >= 5) return this.cartItem.unit_prices[5]
        else return this.cartItem.unit_prices[1]
      }
    },

    methods: {
      removeItem (id) {
        this.$store.dispatch('removeCartItem', id)
      },

      updateItem () {
        this.$store.dispatch('updateCartItem', {
          id: this.cartItem.id,
          quantity: this.cartItem.quantity
        })
      }
    },

    mounted () {
    }
  }
</script>



// WEBPACK FOOTER //
// cart-item.vue?fd069a8c